document.addEventListener(
    'DOMContentLoaded',
    () => {
        const arrivalCard =
            document.querySelector(
                '[data-meetup-arrival]'
            );

        if (!arrivalCard) {
            return;
        }

        const presenceUrl =
            arrivalCard.dataset.presenceUrl;

        const arrivalCount =
            arrivalCard.querySelector(
                '[data-arrival-count]'
            );

        const arrivalButton =
            arrivalCard.querySelector(
                '[data-arrival-button]'
            );

        const arrivalStatus =
            arrivalCard.querySelector(
                '[data-arrival-status]'
            );

        if (
            !presenceUrl
            || !arrivalCount
        ) {
            return;
        }

        let requestInProgress = false;

        const previousStatuses = new Map();

        let initialPresenceLoaded = false;

        const currentMemberId =
            Number(
                document.querySelector(
                    '[data-current-member]'
                )?.dataset.memberId
                ?? 0
            );

        const updateCount = (count) => {
            arrivalCount.textContent =
                `${count} ${
                    count === 1
                        ? 'member'
                        : 'members'
                } here now`;
        };

        const updateMemberBadge = (
            memberId,
            memberStatus
        ) => {
            const memberCard =
                document.querySelector(
                    `[data-meetup-member][data-member-id="${memberId}"]`
                );

            const badge =
                memberCard?.querySelector(
                    '[data-member-arrival-status]'
                );

            if (!badge) {
                return;
            }

            if (memberStatus === 'here') {
                badge.innerHTML = `
                    <span class="inline-flex items-center gap-1.5 font-bold text-emerald-400"><span class="h-2.5 w-2.5 rounded-full bg-emerald-500" aria-hidden="true"></span> Here now</span>
                `;

                return;
            }

            if (memberStatus === 'left') {
                badge.innerHTML = `
                    <span class="inline-flex items-center gap-1.5 font-bold text-slate-500"><span class="h-2.5 w-2.5 rounded-full border border-zinc-400" aria-hidden="true"></span> Left meetup</span>
                `;

                return;
            }

            badge.innerHTML = `
                <span class="text-zinc-600 dark:text-slate-400">
                    Joined meetup
                </span>
            `;
        };

        const updateCurrentMemberInterface = (
            members
        ) => {
            if (
                !arrivalButton
                || !arrivalStatus
            ) {
                return;
            }

            const currentMemberCard =
                document.querySelector(
                    '[data-current-member]'
                );

            const currentMemberId =
                Number(
                    currentMemberCard
                        ?.dataset.memberId
                    ?? 0
                );

            if (!currentMemberId) {
                return;
            }

            const currentMember =
                members.find(
                    member =>
                        Number(member.id)
                        === currentMemberId
                );

            if (!currentMember) {
                return;
            }

            const isHere =
                currentMember.status
                === 'here';

            arrivalButton.dataset.arrived =
                isHere
                    ? 'true'
                    : 'false';

            arrivalButton.textContent =
                isHere
                    ? 'Leave Meetup'
                    : "I'm Here";

            arrivalStatus.innerHTML =
                isHere
                    ? '<span class="inline-flex items-center gap-1.5"><span class="h-2.5 w-2.5 rounded-full bg-emerald-500" aria-hidden="true"></span> You\'re here!</span>'
                    : '<span class="inline-flex items-center gap-1.5"><svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 21s7-5.25 7-12a7 7 0 1 0-14 0c0 6.75 7 12 7 12Z"/><circle cx="12" cy="9" r="2.5"/></svg> You haven\'t checked in yet.</span>';
        };

        const showPresenceToast = (
            memberName,
            status
        ) => {
            if (
                typeof window.showToast
                !== 'function'
            ) {
                return;
            }

            window.showToast({
                type:
                    status === 'here'
                        ? 'success'
                        : 'info',

                title:
                    'Meetup Update',

                message:
                    status === 'here'
                        ? `${memberName} arrived at the meetup.`
                        : `${memberName} left the meetup.`,

                duration:
                    5000,
            });
        };

        const updateActivity = member => {

            if (
                member.status !== 'here'
                && member.status !== 'left'
            ) {
                return;
            }

            const list =
                document.querySelector(
                    '[data-meetup-activity-list]'
                );

            if (!list) {
                return;
            }

            const existing =
                list.querySelector(
                    `[data-member-id="${member.id}"]`
                );

            existing?.remove();

            const row =
                document.createElement('div');

            row.className =
                'flex items-center gap-4 border-b border-white/5 py-4';

            row.dataset.meetupActivityRow = '';
            row.dataset.memberId =
                member.id;
            row.dataset.status =
                member.status;

            const avatar =
                member.profile_photo_url
                    ? `
                <img
                    src="${member.profile_photo_url}"
                    class="h-10 w-10 rounded-full object-cover"
                >
            `
                    : `
                <div class="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-fuchsia-500 to-orange-400 text-xs font-black text-white">
                    ${member.initials}
                </div>
            `;

            row.innerHTML = `
        ${avatar}

        <div class="flex-1">
            <p class="text-sm text-slate-200">
                <span class="font-bold text-zinc-950 dark:text-white">
                    ${member.name}
                </span>

                ${
                member.status === 'here'
                    ? '<span class="text-emerald-300"> arrived at the meetup</span>'
                    : '<span class="text-zinc-600 dark:text-slate-400"> left the meetup</span>'
            }
            </p>

            <p class="mt-1 text-xs text-slate-500">
                just now
            </p>
        </div>

        <span class="block h-2.5 w-2.5 rounded-full ${member.status === 'here' ? 'bg-emerald-500' : 'border border-zinc-400'}" aria-hidden="true"></span>
    `;

            list.prepend(row);

            while (
                list.children.length > 5
                ) {
                list.lastElementChild.remove();
            }

        };

        const pollPresence = async () => {
            if (
                requestInProgress
                || document.hidden
            ) {
                return;
            }

            requestInProgress = true;

            try {
                const response =
                    await fetch(
                        presenceUrl,
                        {
                            credentials:
                                'same-origin',

                            headers: {
                                Accept:
                                    'application/json',

                                'X-Requested-With':
                                    'XMLHttpRequest',
                            },
                        }
                    );

                const data =
                    await response.json()
                        .catch(
                            () => ({})
                        );

                if (!response.ok) {
                    return;
                }

                if (
                    !Array.isArray(
                        data.members
                    )
                ) {
                    return;
                }

                updateCount(
                    Number(
                        data.arrived_count
                        ?? 0
                    )
                );

                data.members.forEach(
                    member => {

                        const id =
                            Number(member.id);

                        updateMemberBadge(
                            id,
                            member.status
                        );

                        const previous =
                            previousStatuses.get(id);

                        if (
                            initialPresenceLoaded
                            && previous
                            && previous.status
                            !== member.status
                            && id !== currentMemberId
                        ) {

                            if (
                                member.status === 'here'
                                || member.status === 'left'
                            ) {
                                showPresenceToast(
                                    previous.name,
                                    member.status
                                );

                                updateActivity(member);
                            }

                        }

                        const memberCard =
                            document.querySelector(
                                `[data-meetup-member][data-member-id="${id}"]`
                            );

                        previousStatuses.set(
                            id,
                            {
                                status:
                                member.status,

                                name:
                                    memberCard
                                        ?.dataset
                                        .memberDisplayName
                                    ?? 'Someone',
                            }
                        );

                    }
                );

                initialPresenceLoaded = true;

                updateCurrentMemberInterface(
                    data.members
                );
            } finally {
                requestInProgress = false;
            }
        };

        pollPresence();

        const intervalId =
            window.setInterval(
                pollPresence,
                5000
            );

        document.addEventListener(
            'visibilitychange',
            () => {
                if (!document.hidden) {
                    pollPresence();
                }
            }
        );

        window.addEventListener(
            'beforeunload',
            () => {
                window.clearInterval(
                    intervalId
                );
            }
        );
    }
);